module.exports = __webpack_public_path__ + "img/confirm-icon.025ee56d.png";